<template>
  <v-container
    style="margin: 0px; padding: 0px; max-width:100%;vertical-align:top;"
  >
    <v-toolbar color="indigo" dark dense>
      <v-toolbar-title>{{ args.desc }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-btn dark text @click.native="close">Close</v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <div class="compact-form" style="margin-left: 20px;vertical-align:top;">
      <v-layout row align-center justify="center" style="vertical-align:top;">
        <v-radio-group v-model="mode" row class="text-h4">
          <v-radio label="Add New" value="new"></v-radio>
          <v-radio label="Edit Existing" value="existing"></v-radio>
        </v-radio-group>

        <v-autocomplete
          clearable
          style="margin: 0px; padding-top: 25px; padding-right: 20px;"
          dense
          v-if="mode == 'existing'"
          outlined
          v-model="selectedBot"
          :items="botList"
          label="Select Bot"
          item-text="name"
          item-value="_id"
        >
          <template slot="selection" slot-scope="data">
            {{ data.item.name }}
          </template>
          <template slot="item" slot-scope="data">
            {{ data.item.name }}
          </template>
        </v-autocomplete>
        <v-spacer />
        <v-flex xs1>
          <v-btn
            color="red"
            :disabled="!name || !usedBy || !botType"
            @click="remove"
            >DELETE</v-btn
          >
          <v-btn
            color="blue"
            :disabled="!name || !usedBy || !botType"
            @click="save"
            >Save</v-btn
          >
        </v-flex>
      </v-layout>
      <v-expansion-panels accordion multiple v-model="panel">
        <v-expansion-panel v-model="panel" expand>
          <v-expansion-panel-header>
            <h2 class="text-h4 pl-4">Overview: {{ name }}</h2>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-layout row align-center>
              <v-flex xs12 class="pl-10">
                <v-chip
                  class="ma-2"
                  large
                  pill
                  :color="dark ? 'cyan darken-1' : 'cyan lighten-3'"
                  >Bot ID: {{ botID }}</v-chip
                >
                <v-chip class="pa-5" large pill :color="botType_color"
                  >Type: {{ botType }}</v-chip
                >
                <v-chip
                  class="ma-2"
                  large
                  pill
                  v-if="notLambda"
                  :color="botDeployment_color"
                  >Deployment Status: {{ IsDeploy }}</v-chip
                >
                <v-chip class="ma-2" large pill v-if="notLambda"
                  >Deployment Started: {{ lastStart }}</v-chip
                >
                <v-chip class="ma-2" large pill v-if="notLambda"
                  >Deployment Ended: {{ lastEnd }}</v-chip
                >
                <v-chip class="ma-2" large pill :color="botStatus_color"
                  >Status: {{ botStatus_name }}</v-chip
                >
              </v-flex>
            </v-layout>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-header>
            <h2 class="text-h4 pl-4">Maintenance Commands</h2>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-btn-toggle borderless tile color="deep-purple accent-1" group>
              <v-btn value="mount" @click="start_deployment">
                <span class="hidden-sm-and-down">Deploy</span>
                <v-icon right>
                  mdi-rocket-launch
                </v-icon>
              </v-btn>
              <v-btn value="unmount" @click="remove_deployment">
                <span class="hidden-sm-and-down">Cancel Deployment</span>
                <v-icon right>
                  mdi-close-octagon
                </v-icon>
              </v-btn>
              <v-btn value ="log" @click="get_bot_log">
                <span class="hidden-sm-and-down">Get Logs</span>
                <v-icon right>
                  mdi-file-cog
                </v-icon>
              </v-btn>
            </v-btn-toggle>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel>
          <v-expansion-panel-header>
            <h2 class="text-h4 pl-4">Definition</h2>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-layout row align-baseline>
              <v-flex xs12 class="pl-10">
                <v-text-field
                  v-model="name"
                  label="Name"
                  clearable
                ></v-text-field>
                <v-autocomplete
                  clearable
                  multiple
                  v-model="usedBy"
                  label="Used By"
                  outlined
                  :items="modules"
                  item-text="name"
                  item-value="_id"
                ></v-autocomplete>
                <v-autocomplete
                  clearable
                  v-model="botType"
                  label="Type"
                  outlined
                  :items="botTypeChoices"
                ></v-autocomplete>
                <v-autocomplete
                  clearable
                  v-model="developer"
                  label="Developer"
                  outlined
                  :items="developerChoices"
                  item-text="firstname"
                  item-value="_id"
                >
                  <template slot="selection" slot-scope="data">
                    Developer: {{ data.item.firstname }} - Email:
                    {{ data.item.email }}
                  </template>
                  <template slot="item" slot-scope="data">
                    Developer: {{ data.item.firstname }} - Email:
                    {{ data.item.email }}
                  </template>
                </v-autocomplete>
                <v-switch
                  v-model="botActive"
                  label="Active Bot"
                  color="success"
                  hide-details
                ></v-switch>
              </v-flex>
            </v-layout>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-header>
            <h2 class="text-h4 pl-4">
              Current Deployments: {{ deployCart.length }}
            </h2>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-flex xs12>
              <v-spacer></v-spacer>
              <server-table-component
                :rowProp="deployCart"
                :schema="deploySchema"
                :table="deploySchema"
                embed
                class="pl-5"
                :editable="false"
              ></server-table-component>
            </v-flex>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel>
          <v-expansion-panel-header>
            <h2 class="text-h4 pl-4">Available Bot Logs: {{ botLogs.length }}</h2>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-container fluid pl-10 fillheight>
              <v-card v-if="botLogs.length > 0">
                <v-slide-y-transition class="py-0" group tag="v-list">
                  <template v-for="(log, i) in botLogs">
                    <v-divider
                      :key="`${i}-divider`"
                      style="background-color:grey"
                    ></v-divider>

                    <v-list-item
                      :key="`${i}-${log.id}`"
                      class="px-0 py-0 ma-0"
                      align="top"
                    >
                      
                      <v-card width="100%">
                        <v-card-title class="py-5"> Logs for Deployment ID: {{ log.id}}
                        </v-card-title>
                        <v-card-text> <pre>{{ log.log }}</pre>
                        </v-card-text>
                      </v-card>
                    </v-list-item>
                  </template>
                </v-slide-y-transition>
              </v-card>
              <v-divider class="mt-4"></v-divider>
            </v-container>
          </v-expansion-panel-content>
        </v-expansion-panel>



        <v-expansion-panel>
          <v-expansion-panel-header>
            <h2 class="text-h4 pl-4">Triggers: {{ triggerTable.length }}</h2>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-container fluid pl-10 fillheight>
              <v-text-field
                v-model="newTable"
                clearable
                filled
                rounded
                label="Add Trigger Table"
                :background-color="dark ? '#546E7A' : '#B0BEC5'"
                solo
                @keydown.enter="createTriggerTable"
              >
                <template v-slot:prepend>
                  <v-fade-transition>
                    <v-icon v-if="newTable" @click="createTriggerTable"
                      >mdi-plus</v-icon
                    >
                  </v-fade-transition>
                </template>
              </v-text-field>
              <v-divider class="mb-4"></v-divider>

              <v-card v-if="triggerTable.length > 0">
                <v-slide-y-transition class="py-0" group tag="v-list">
                  <template v-for="(trigger, i) in triggerTable">
                    <v-divider
                      :key="`${i}-divider`"
                      style="background-color:grey"
                    ></v-divider>

                    <v-list-item
                      :key="`${i}-${trigger.table}`"
                      class="px-0 py-0 ma-0"
                      align="top"
                    >
                      <v-card width="30%" flat>
                        <v-card-title
                          >TABLE:<br />{{ trigger.table }}</v-card-title
                        >
                        <v-spacer></v-spacer>
                        <v-card-actions>
                          <v-btn
                            :color="dark ? '#D32F2F' : '#EF5350'"
                            @click="removeTriggerTable(trigger)"
                            >Remove Table</v-btn
                          >
                        </v-card-actions>
                      </v-card>
                      <v-divider vertical></v-divider>
                      <v-card width="100%">
                        <v-card-title class="py-5">
                          <v-text-field
                            v-model="trigger.newCondition"
                            clearable
                            rounded
                            :background-color="dark ? '#546E7A' : '#B0BEC5'"
                            label="Add Trigger Condition"
                            solo
                            @keydown.enter="createTriggerCondition(trigger)"
                          >
                            <template v-slot:prepend>
                              <v-fade-transition>
                                <v-icon
                                  v-if="trigger.newCondition"
                                  @click="createTriggerCondition(trigger)"
                                  >mdi-plus</v-icon
                                >
                              </v-fade-transition>
                            </template>
                          </v-text-field>
                        </v-card-title>
                        <v-card-text
                          ><h2 class="text-h5 pl-4">
                            Trigger Conditions
                          </h2></v-card-text
                        >
                        <v-list>
                          <template v-for="(action, k) in trigger.actions">
                            <v-divider :key="`${k}-divider`"></v-divider>
                            <v-list-item :key="k">
                              <v-list-item-content>
                                <v-list-item-title>{{
                                  action
                                }}</v-list-item-title>
                              </v-list-item-content>
                              <v-spacer></v-spacer>
                              <v-btn
                                fab
                                x-small
                                rounded
                                color="error"
                                @click="removeTriggerCondition(trigger, k)"
                                ><v-icon>mdi-trash-can</v-icon></v-btn
                              >
                            </v-list-item>
                          </template>
                        </v-list>
                      </v-card>
                    </v-list-item>
                  </template>
                </v-slide-y-transition>
              </v-card>
              <v-divider class="mt-4"></v-divider>
            </v-container>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-header>
            <h2 class="text-h4 pl-4">Routing Paths: {{ routes.length }}</h2>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <server-table-component
              :rowProp="routes"
              :schema="routeSchema"
              :table="routeSchema"
              embed
              class="pl-5"
              :editable="false"
            ></server-table-component>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-header>
            <h2 class="text-h4 pl-4">History: {{ history.length }} Events</h2>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-flex xs12>
              <v-spacer></v-spacer>
              <server-table-component
                :rowProp="history"
                :schema="historySchema"
                :table="historySchema"
                embed
                class="pl-5"
                :editable="false"
              ></server-table-component>
            </v-flex>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>
  </v-container>
</template>
<script>
import { sync } from "vuex-pathify";
import axiosInstances from "@/../../coreui/server/axiosInstances";
import utils from "@/../../coreui/helpers/utils";
export default {
  props: ["args"],
  data: () => ({
    mode: "new",
    modules: [],
    botchoices: [],
    selectedBot: null,
    botList: [],
    routeSchema: "sch_uibot_routes",
    historySchema: "sch_set_history",
    deploySchema: "sch_uibot_deployment",
    newTable: null,
    newCondition: null,
    triggerTable: [],
    botTypeChoices: ["Standard", "Lambda", "Parking Lot"],
    botType: null,
    botID: null,
    botRecID: null,
    botActive: false,
    rabbit: null,
    lambda: null,
    IsUsed: null,
    IsDeploy: null,
    deploymentTarget: null,
    lastStart: null,
    lastEnd: null,
    parking: null,
    history: [],
    name: null,
    usedBy: null,
    developer: null,
    developerChoices: [],
    routes: [],
    notLambda: true,
    panel: [0],
    deployCart: [],
    botLogs: []
  }),
  computed: {
    loader: sync("login/loader"),
    botStatus_color() {
      if (this.botActive)
        return this.dark ? "green darken-1" : "green lighten-3";
      else return this.dark ? "blue-grey darken-4" : "blue-grey lighten-3";
    },
    botDeployment_color() {
      if (this.IsDeploy === "Deployed")
        return this.dark ? "green darken-1" : "green lighten-3";
      else return this.dark ? "blue-grey darken-4" : "blue-grey lighten-3";
    },
    botStatus_name() {
      if (this.botActive) return "Active";
      else return "Inactive";
    },
    botType_color() {
      if (this.botType === "Standard") return "primary";
      else if (this.botType === "Lambda") {
        this.notLambda = false;
        return this.dark ? "purple darken-4" : "purple lighten-4";
      } else
        return this.dark ? "deep-orange darken-4" : "deep-orange lighten-3";
    },
    mqttTableUpdated: sync("mqtt/mqttTableUpdated"),
    dark: sync("misc/dark"),
  },
  watch: {
    mode: {
      async handler(val) {
        this.clear();
        if (val == "new") {
        } else {
          let curBots = await axiosInstances.loginServer.get("/dt/v1/auth_bot");
          let dataSet = curBots.data;
          this.botList = dataSet.sort((a, b) =>
            a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1
          );
        }
      },
      mqttTableUpdated: {
        async handler(val) {
          this.elog("debug", "mqtt callback for updating table: {}", val)();
          if (val === "auth_bot") {
            this.mqttTableUpdated = "";
            if (this.botRecID !== null) {
              // Reload the record in case it was updated
              let updateObject = await axiosInstances.loginServer.get(
                `/dt/v1/auth_bot/${this.botRecID}`
              );
              let updateData = updateObject.data;
              this.assignBotData(updateData);
            }
          }
        },
      },
    },
    cmdDialog(val) {
      val || this.close();
    },
    selectedBot(val) {
      let botRecord = this.botList.find((x) => x["_id"] === val);
      this.elog("debug", "Bot Record = {}", botRecord)();
      if (botRecord === undefined) {
        this.clear();
      } else {
        this.assignBotData(botRecord);
      }
    },
  },
  methods: {
    assignBotData(botRecord) {
      this.botRecID = botRecord["_id"];
      this.botID = botRecord["botID"];
      this.name = botRecord["name"];
      this.usedBy = botRecord["usedBy"];
      this.lastStart = utils.displayFormat(botRecord["laststart"], "dateWSeconds");
      this.lastEnd =
        botRecord["laststart"] !== botRecord["lastend"]
          ? utils.displayFormat(botRecord["lastend"], "dateWSeconds")
          : "N/A";
      this.routes = botRecord.hasOwnProperty("routes")
        ? botRecord["routes"]
        : [];
      this.history = botRecord.hasOwnProperty("history")
        ? botRecord["history"]
        : [];
      if (botRecord.hasOwnProperty("deployCart")) {
        let entries = botRecord["deployCart"];
        let withLogs = entries.filter(x => x.hasOwnProperty("logData"))
        this.deployCart = [];
        this.botLogs = []
        for (const item of entries) {
          let obj = { id: item?.id?.toString(), server: item?.server, sc: item?.sc, IsOrg: item?.IsOrg, status: item?.status, org: item?.org};
          this.deployCart.push(obj);
        }
        for (const item of withLogs){
          let obj = { id: item?.id?.toString(), log: item?.logData}
          console.log(`Log Data = ${item.logData}`)
          this.botLogs.push(obj)
        }
      }
      this.IsDeploy = botRecord.hasOwnProperty("isDeploy")
        ? botRecord["isDeploy"] === "yes"
          ? "Deployed"
          : "Not Deployed"
        : "Not Deployed";
      if (botRecord.hasOwnProperty("triggers")) {
        for (const entry of botRecord["triggers"]) {
          let obj = {};
          obj.table = entry.table;
          obj.actions = [];
          for (const action of entry.actions) {
            obj.actions.push(action.src);
          }
          this.triggerTable.push(obj);
        }
      }
      this.developer = botRecord.hasOwnProperty("developer")
        ? botRecord["developer"]
        : null;
      if (botRecord.hasOwnProperty("lambda") && botRecord.lambda === "yes")
        this.botType = "Lambda";
      else if (
        botRecord.hasOwnProperty("parking") &&
        botRecord.parking === "yes"
      ) {
        this.botType = "Parking Lot";
      } else this.botType = "Standard";
      this.deploymentTarget = botRecord.hasOwnProperty("target")
        ? botRecord.target
        : null;
      this.IsUsed = botRecord.hasOwnProperty("IsUsed")
        ? botRecord.IsUsed
        : "no";
      if (this.IsUsed === "yes") this.botActive = true;
      else this.botActive = false;
    },
    createTriggerCondition(item) {
      let tableIndex = this.triggerTable.findIndex(
        (x) => x.table === item.table
      );
      // Check if actions already exist or not
      if (!this.triggerTable[tableIndex].hasOwnProperty("actions")) {
        this.$set(this.triggerTable[tableIndex], "actions", []);
      }
      this.triggerTable[tableIndex].actions.push(item.newCondition);
      this.triggerTable[tableIndex].newCondition = null;
    },
    async removeTriggerCondition(item, index) {
      var self = this;
      this.$root
        .$confirm("Delete", "Are you sure you want to delete this item?", {
          color: "red",
        })
        .then(function(confirm) {
          if (confirm) {
            let tableIndex = self.triggerTable.findIndex(
              (x) => x.table === item.table
            );
            self.triggerTable[tableIndex].actions.splice(index, 1);
          }
        });
    },
    createTriggerTable() {
      this.triggerTable.push({ table: this.newTable });
      this.newTable = null;
    },
    async removeTriggerTable(item) {
      var self = this;
      this.$root
        .$confirm("Delete", "Are you sure you want to delete this item?", {
          color: "red",
        })
        .then(function(confirm) {
          if (confirm) {
            let index = self.triggerTable.findIndex(
              (x) => x.table === item.table
            );
            self.triggerTable.splice(index, 1);
          }
        });
    },
    close() {
      this.$router.go(-1);
    },
    async startDeployment(){
      let payload = {};
      payload.action = "bot_mount_extra"
      payload.target = this.name
      let expectedCount = this.deployCart.length + 1
      await axiosInstances.apiServer.post("/dt/v1/temp_default", payload)
      let finished = false;
      let freshRecord = null;
      while (!finished){
        console.log(`Rec ID = ${this.botRecID}`);
        freshRecord = await axiosInstances.loginServer.get(
          `/dt/v1/auth_bot/${this.botRecID}`
        );
        console.log(
          `Fresh Record Deployment Count = ${freshRecord.data["deployCart"].length}`
        );
        if (freshRecord.data.deployCart.length !== expectedCount) await this.sleep(200);
        else finished = true;
      }
      this.assignBotData(freshRecord.data);
      this.loader.hide();
    },
    async startRemoval() {
      let payload = {};
      payload.action = "bot_unmount_all";
      payload.target = this.name;
      await axiosInstances.apiServer.post("/dt/v1/temp_default", payload);
      let finished = false;
      let freshRecord = null;
      while (!finished) {
        console.log(`Rec ID = ${this.botRecID}`);
        freshRecord = await axiosInstances.loginServer.get(
          `/dt/v1/auth_bot/${this.botRecID}`
        );
        console.log(
          `Fresh Record Deployment = ${freshRecord.data["isDeploy"]}`
        );
        if (freshRecord.data.isDeploy !== "no") await this.sleep(200);
        else finished = true;
      }
      this.assignBotData(freshRecord.data);
      this.loader.hide();
    },
    async remove_deployment() {
      var self = this;
      this.$root
        .$confirm(
          "Remove Deployment",
          `This action will remove all running copies of ${self.name}. Are you sure you want to do this?`,
          { color: "red" }
        )
        .then(function(confirm) {
          if (confirm) {
            console.log(`Decided to remove bot = ${self.name}`);
            self.loader = self.$loading.show({
              container: null, //full page
              onCancel: false, // can't cancel
              loader: "dots", // 'spinner' , 'dots' or 'bars',
              opacity: 0.75,
              backgroundColor: "#000000",
              color: "#475fb3",
              zIndex: 999,
            });
            self.startRemoval();
          }
        });
    },
    async start_deployment() {
      var self = this;
      this.$root
        .$confirm(
          "Deploy Bot",
          `This action will deploy and start a copy of ${self.name}. Are you sure you want to do this?`,
          { color: "green" }
        )
        .then(function(confirm) {
          if (confirm) {
            console.log(`Decided to start bot = ${self.name}`);
            self.loader = self.$loading.show({
              container: null,
              onCancel: false,
              loader: "dots",
              opacity: 0.75,
              backgroundColor: "#000000",
              color: "#475fb3",
              zIndex: 999,
            });
            self.startDeployment()
          }
        });
    },
    async fetchLogs(){
      let payload = {};
      payload.action = "bot_get_log"
      payload.target = this.name
      let expectedCount = this.deployCart.length + 1
      await axiosInstances.apiServer.post("/dt/v1/temp_default", payload)
      let finished = false;
      let freshRecord = null;
      while (!finished){
        console.log(`Rec ID = ${this.botRecID}`);
        freshRecord = await axiosInstances.loginServer.get(
          `/dt/v1/auth_bot/${this.botRecID}`
        );
        let deployCart = freshRecord.data["deployCart"]
        let withLogs = deployCart.filter(x => x.hasOwnProperty("logData"))
        console.log(
          `Deployment Count = ${deployCart.length} Log Count = ${withLogs.length}`
        );
        
        if (deployCart.length !== withLogs.length) await this.sleep(500);
        else finished = true;
      }
      this.assignBotData(freshRecord.data);
      this.loader.hide();
    },
    async get_bot_log() {
      var self = this
      this.$root.$confirm("Get Bot Logs", `This action will fetch the last 100 lines of the log for each running instance of this bot. Are you sure you want to do this?`,
      {color: "green"})
      .then(function(confirm){
        if(confirm){
          console.log(`Decided to get logs for bot = ${self.name}`);
            self.loader = self.$loading.show({
              container: null,
              onCancel: false,
              loader: "dots",
              opacity: 0.75,
              backgroundColor: "#000000",
              color: "#475fb3",
              zIndex: 999,
            });
            self.fetchLogs()
        }
      })
    },
    async sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
    async remove() {
      let payload = {};
      payload.request_action = "remove"
      payload.bot_recid = this.botRecID ? this.botRecID : null
      // Write the date to the temp table for the bot to handle
      await axiosInstances.loginServer.post("/dt/v1/temp_bot", payload)
      this.mode = "new";
      this.clear();
    },
    async save() {
      let payload = {};
      payload.IsUsed = this.botActive ? "yes" : "no";
      payload.name = this.name;
      payload.usedBy = this.usedBy;
      payload.request_action = this.botRecID ? "update" : "create"
      payload.bot_recid = this.botRecID ? this.botRecID : null
      // Create / Update the trigger table it not empty
      if (this.triggerTable.length > 0) {
        let updateTriggerTable = [];
        for (const entry of this.triggerTable) {
          let obj = {};
          obj.table = entry.table;
          obj.actions = [];
          for (const key of entry.actions) {
            obj.actions.push({ src: key });
          }
          updateTriggerTable.push(obj);
        }
        payload.triggers = updateTriggerTable;
      } else {
        payload.triggers = []
      }
      payload.target = this.deploymentTarget;
      payload.developer = this.developer;
      // Map the type of bot to different actions
      if (this.botType === "Standard") {
        payload.lambda = "no";
        payload.parking = "no";
        payload.standard = "yes";
      } else if (this.botType === "Lambda") {
        payload.lambda = "yes";
        payload.parking = "no";
        payload.standard = "no";
      } else {
        payload.lambda = "no";
        payload.parking = "yes";
        payload.standard = "no";
      }

      // Write the date to the temp table for the bot to handle
      await axiosInstances.loginServer.post("/dt/v1/temp_bot", payload)
      this.mode = "new";
      this.clear();
    },
    clear() {
      this.selectedBot = null;
      this.triggerTable = [];
      this.history = [];
      this.routes = [];
      this.botType = null;
      this.botID = null;
      this.botRecID = null;
      this.name = null;
      this.usedBy = [];
      this.botActive = false;
      this.notLambda = true;
      this.IsDeploy = null;
      this.deployCart = [];
      this.botLogs = []
    },
  },
  async mounted() {
    // Get the modules and bots needed for this module
    let modules = await axiosInstances.loginServer.get("/dt/v1/sup_modules");
    let botChoices = await axiosInstances.loginServer.get("/dt/v1/auth_bot");
    let developerChoices = await axiosInstances.loginServer.get("/dt/v1/users");

    // Filter developer choices to Entrinsia Emails Only
    let developerFilter = developerChoices.data.filter((x) =>
      x.email.includes("entrinsia.com")
    );

    // Sort the names for ease of use
    console.log(`Modules: `, modules.data)
    console.log(`Bot Choices: `, botChoices.data)
    console.log(`Developers: `, developerChoices.data)
    let sortedModules = modules.data.sort((a, b) =>
      a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1
    );
    console.log(`Sorted Modules = `, sortedModules)
    let sortedBots = botChoices.data.sort((a, b) =>
      a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1
    );
    let sortedDevelopers = developerFilter.sort((a, b) =>
      a.firstname.toLowerCase() > b.firstname.toLowerCase() ? 1 : -1
    );

    // Set the values for the rest of the component to use
    this.modules = sortedModules;
    this.botchoices = sortedBots;
    this.developerChoices = sortedDevelopers;
  },
};
</script>
<style scoped>
.compact-form {
  transform: scale(0.95);
  transform-origin: top;
}
.card-outter {
  padding-bottom: 50px;
}
.card-actions {
  position: absolute;
  bottom: 0;
}
.flexcard {
  display: flex;
  flex-direction: column;
}
</style>
